module.exports = __webpack_public_path__ + "ClientApp/images/Body_contouring_2.jpeg";